"use client";

import type { ReactNode } from "react";
import { createContext, useContext } from "react";

type NavBarActionsContextValue = {
  actions: ReactNode;
  setActions: (actions: ReactNode) => void;
};

const NavBarActionsContext = createContext<NavBarActionsContextValue | null>(
  null,
);

export const NavBarActionsProvider = ({
  value,
  children,
}: {
  value: NavBarActionsContextValue;
  children: ReactNode;
}) => {
  return (
    <NavBarActionsContext.Provider value={value}>
      {children}
    </NavBarActionsContext.Provider>
  );
};

export const useNavBarActions = () => {
  const context = useContext(NavBarActionsContext);
  if (!context) {
    throw new Error("useNavBarActions must be used within a provider");
  }
  return context;
};

export const useOptionalNavBarActions = () => {
  return useContext(NavBarActionsContext);
};
